<template>
    <div class="top">
      <el-row style="float: left;" class="topright">
        <b style="text-align: center;cursor: pointer;" @click="back()">返回</b>
      </el-row>
     <!-- <el-breadcrumb class="left" separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
        <el-breadcrumb-item>活动列表</el-breadcrumb-item>
        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div class="right topright">
        <el-button type="primary" class="studybtn left" round @click="goTo('/home')">我要学习</el-button>
          <el-dropdown style="min-width: 130px;height: 50px;">
            <span class="el-dropdown-link">
          <!-- <img :src="info.img" style="width: 30px;padding: 10px;float: left;" /> -->
              <div class="headimg left">
                <el-avatar :src="info.img"></el-avatar>
              </div>
              <b style="line-height: 50px;float: left;min-width: 50px;">{{info.rale_name}}</b>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link to="/personal"><i class="el-icon-user"></i> 个人中心</router-link>
              </el-dropdown-item>
              <!-- <el-dropdown-item icon="el-icon-sort">转让管理员</el-dropdown-item> -->
              <el-dropdown-item >
                <span @click="logout()"><i class="el-icon-switch-button"></i> 退出登录</span>
               <!-- <router-link to="/login"><i class="el-icon-switch-button"></i> 退出登录</router-link> -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
      </div>
    </div>


</template>

<script>
  export default {
    data() {
      return {
        info:this.$store.state.info,
      };
    },
    mounted:function(){
    },
    methods: {
      back(){
        // this.$router.go(-1);
         window.parent.history.back(-1);
        // this.$route.query.choice=''
        // console.log(this.$route.query.choice)

      },
      handleSelect(key, keyPath) {

      },
      /* 原页面 */
      goTo(url) {
        this.$router.push(url);
      },
      logout(){
        localStorage.setItem('authorization', '')
        this.$store.commit('info_save', null)
        this.$message.success('成功退出,即将前往登录页');//弹框
        setTimeout(()=>{
          this.$router.push({
            path: '/login',
            query: {redirect: this.$route.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        },1000)
      },
    },
  }
</script>

<style scoped>
  .headimg,
  .headmsg {
    margin: 5px;
  }
  .top {
    width: calc( 100% - 40px);
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    min-width: 560px;
    background-color: white;
    padding: 0 20px;
    z-index: 999;
  }
  .el-breadcrumb {
    height: 50px;
    line-height: 50px;
    max-width: 300px;
  }

  .topright {
    height: 50px;
    line-height: 50px;
    margin-right: 20px;
  }

  .studybtn {
    margin: 10px 20px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px !important;
  }
  router-link:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  router-link:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  router-link:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  router-link:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }
  a:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  a:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  a:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  a:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }

</style>



// WEBPACK FOOTER //
// src/components/company/public/NavTop.vue